module.exports = __webpack_public_path__ + "static/media/ellipsisHover.26eccff7.svg";